/* =========================================================
   Affiche SURF — le plan de shape, le quiver, le spot, la session, le heat.
   API : SNSfPlanche.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, lieu, joueur, equipe,
              mode 'planche' → type, pieds, pouces, largeur, epaisseur, volume,
                               tail, ailerons, shaper, modele
              mode 'quiver'  → q1..q6 (« shortboard|5'10|18 3/4|2 1/4|Petites conditions »)
              mode 'spot'    → break, sens, houle, vent, maree, periode
              mode 'session' → l1..l8 (« Libellé|valeur »)
              mode 'heat'    → h1..h6 (notes de 0 à 10), comptees, resultat }
     opts : { palette }

   CE QUI EST IMPRIMÉ COMME OFFICIEL : rien. Le barème de jugement du surf
   diffère entre la WSL et l'ISA — donc entre le circuit pro et les Jeux — au
   point que les bandes descriptives (Poor / Fair / Good…) ne sont pas les
   mêmes des deux côtés. L'affiche « heat » se contente donc d'une colonne
   graduée de 0 à 10 et des notes que le client a réellement obtenues.

   Auto-suffisant (aucun fetch, aucune image, aucun aléa) → re-render serveur.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    ocean:  { label:'Océan',  bg:'#07222E', ink:'#EEF6F6', muted:'#7EA3AC', accent:'#F2A73B', line:'#12414F', card:'#0D3140', eau:'#0F4A5C', sable:'#C9A87C' },
    calque: { label:'Calque', bg:'#F2EFE6', ink:'#1B2A32', muted:'#7E8A8E', accent:'#C2410C', line:'#DCD6C8', card:'#FBF9F3', eau:'#CFE3E6', sable:'#E2D3B4' },
    couchant:{label:'Couchant',bg:'#2A1726', ink:'#F7EDEF', muted:'#B58FA6', accent:'#F2A73B', line:'#452740', card:'#371F33', eau:'#4A2A44', sable:'#C9A87C' },
    nuit:   { label:'Nuit',   bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', eau:'#123E70', sable:'#C9A87C' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  /** « 19 1/4 », « 19.25 » ou « 19,25 » → 19.25. Null si illisible. */
  function pouces(s) {
    const t = String(s == null ? '' : s).trim().replace(',', '.').replace(/["]/g, '');
    if (!t) return null;
    const m = t.match(/^(\d+(?:\.\d+)?)(?:\s+(\d+)\s*\/\s*(\d+))?$/);
    if (!m) return null;
    let v = parseFloat(m[1]);
    if (m[2] && m[3] && +m[3] !== 0) v += (+m[2]) / (+m[3]);
    return Number.isFinite(v) && v > 0 ? v : null;
  }
  /** Pieds + pouces → pouces. « 6 » et « 2 » → 74. */
  const longueurPouces = (p, po) => {
    const a = parseFloat(String(p == null ? '' : p).replace(',', '.')), b = pouces(po) || 0;
    return Number.isFinite(a) && a > 0 ? a * 12 + b : null;
  };
  /** 74 → « 6'2 ». Notation de shaper, en apostrophe simple ASCII. */
  const enPieds = v => `${Math.floor(v / 12)}'${(Math.round((v % 12) * 100) / 100).toString().replace(/\.0+$/, '')}`;

  /* Familles de planches. TABLES FERMÉES : la saisie du client sert de clé,
     jamais de valeur — rien de ce qui vient du formulaire n'atteint un
     attribut SVG par ce chemin.
       pv   = position du maître-bau, en fraction de la longueur depuis le nose
       nez  = « rondeur » du nose (part de la demi-largeur atteinte tôt)
       cul  = largeur du tail, en fraction de la demi-largeur max */
  const PLANCHES = {
    shortboard: { label: 'Shortboard', pv: 0.52, nez: 0.20, cul: 0.42, tail: 'squash',  ailerons: 'thruster' },
    fish:       { label: 'Fish',       pv: 0.50, nez: 0.34, cul: 0.66, tail: 'swallow', ailerons: 'twin' },
    funboard:   { label: 'Funboard',   pv: 0.50, nez: 0.40, cul: 0.52, tail: 'round',   ailerons: '2+1' },
    longboard:  { label: 'Longboard',  pv: 0.50, nez: 0.54, cul: 0.50, tail: 'square',  ailerons: 'single' },
    gun:        { label: 'Gun',        pv: 0.46, nez: 0.18, cul: 0.28, tail: 'pin',     ailerons: 'thruster' },
  };
  const TAILS = { squash: 'Squash', square: 'Square', round: 'Round', pin: 'Pin', swallow: 'Swallow' };
  const AILERONS = { single: 'Single', twin: 'Twin', thruster: 'Thruster', quad: 'Quad', '2+1': '2 + 1' };
  const cle = (v, table, defaut) => {
    const k = String(v == null ? '' : v).trim().toLowerCase().replace(/\s+/g, '');
    return Object.prototype.hasOwnProperty.call(table, k) ? k : defaut;
  };

  /* ---------------------------------------------------------------
     LE CONTOUR, calculé et non décoratif. Deux Béziers cubiques en miroir,
     du nose au tail, dont le maître-bau et sa position viennent des cotes
     saisies. L'échelle est en pixels par POUCE : deux planches rendues à la
     même échelle gardent donc leur écart de taille réel, ce qui est tout le
     sujet du mode « quiver ».
     --------------------------------------------------------------- */
  function contour(cx, y0, L, W, def, tailId, ailId, s, p, trait) {
    const hL = L * s, hw = (W / 2) * s;             /* longueur et demi-largeur, en unités */
    const yv = y0 + hL * def.pv;                    /* maître-bau */
    const cul = Math.max(hw * 0.10, hw * def.cul);
    const yF = y0 + hL;
    const encoche = tailId === 'swallow' ? Math.min(hL * 0.055, 3 * s) : 0;  /* 3 pouces, pas un V de chauve-souris */

    /* Les points de contrôle du BORD DROIT, nommés une fois. Le bord gauche
       est le même parcouru À L'ENVERS : un cubique C p1 p2 p3 se retourne en
       C p2 p1 p0. On les écrit donc explicitement plutôt que de retourner la
       chaîne du chemin — une inversion par expression régulière tient tant
       qu'on ne touche à rien, ce qui n'est jamais le cas. */
    const P = (sg, x, y) => `${(cx + sg * x).toFixed(1)} ${y.toFixed(1)}`;
    const a1 = [hw * def.nez, y0 + hL * 0.14], a2 = [hw, yv - hL * 0.20], a3 = [hw, yv];
    const b1 = [hw, yv + hL * 0.22], b2 = [cul + (hw - cul) * 0.55, yF - hL * 0.12], b3 = [cul, yF];

    let d = `M ${cx} ${y0.toFixed(1)}`
      + ` C ${P(1, a1[0], a1[1])} ${P(1, a2[0], a2[1])} ${P(1, a3[0], a3[1])}`
      + ` C ${P(1, b1[0], b1[1])} ${P(1, b2[0], b2[1])} ${P(1, b3[0], b3[1])}`;

    /* la découpe du tail, d'un bord à l'autre */
    if (tailId === 'swallow')
      d += ` L ${(cx + cul*0.55).toFixed(1)} ${yF.toFixed(1)} Q ${cx} ${(yF - encoche).toFixed(1)} ${(cx - cul*0.55).toFixed(1)} ${yF.toFixed(1)} L ${(cx - cul).toFixed(1)} ${yF.toFixed(1)}`;
    else if (tailId === 'round' || tailId === 'pin')
      d += ` Q ${cx} ${(yF + cul*0.75).toFixed(1)} ${(cx - cul).toFixed(1)} ${yF.toFixed(1)}`;
    else if (tailId === 'squash')
      d += ` L ${(cx + cul*0.62).toFixed(1)} ${(yF + cul*0.16).toFixed(1)} Q ${cx} ${(yF + cul*0.30).toFixed(1)} ${(cx - cul*0.62).toFixed(1)} ${(yF + cul*0.16).toFixed(1)} L ${(cx - cul).toFixed(1)} ${yF.toFixed(1)}`;
    else /* square */
      d += ` L ${(cx - cul).toFixed(1)} ${yF.toFixed(1)}`;

    /* remontée par le bord gauche : mêmes points, ordre inversé */
    d += ` C ${P(-1, b2[0], b2[1])} ${P(-1, b1[0], b1[1])} ${P(-1, a3[0], a3[1])}`
      + ` C ${P(-1, a2[0], a2[1])} ${P(-1, a1[0], a1[1])} ${cx} ${y0.toFixed(1)} Z`;

    let g = `<path d="${d}" fill="${p.card}" stroke="${trait}" stroke-width="${Math.max(1.6, hw * 0.030).toFixed(1)}" stroke-linejoin="round"/>`;
    /* le stringer, de la pointe au tail */
    g += `<line x1="${cx}" y1="${(y0 + hL*0.012).toFixed(1)}" x2="${cx}" y2="${(yF - encoche - hL*0.004).toFixed(1)}" stroke="${trait}" stroke-width="${Math.max(0.8, hw*0.014).toFixed(1)}" opacity="0.55"/>`;

    /* Les boîtiers d'ailerons, posés selon le setup choisi. Rien d'inventé :
       ce sont des positions d'usage, pas des cotes réglementaires — aucune
       fédération ne normalise le placement d'un aileron. */
    const r = Math.max(2.2, hw * 0.075);
    const dessine = (dx, dy) => `<ellipse cx="${(cx + dx).toFixed(1)}" cy="${(yF - dy).toFixed(1)}" rx="${(r*0.55).toFixed(1)}" ry="${r.toFixed(1)}" fill="${trait}" opacity="0.75"/>`;
    const arr = hL * 0.055, lat = hL * 0.105;
    if (ailId === 'single') g += dessine(0, hL * 0.16);
    else if (ailId === 'twin') g += dessine(-hw*0.60, lat) + dessine(hw*0.60, lat);
    else if (ailId === 'thruster') g += dessine(0, arr) + dessine(-hw*0.58, lat) + dessine(hw*0.58, lat);
    else if (ailId === 'quad') g += dessine(-hw*0.44, arr) + dessine(hw*0.44, arr) + dessine(-hw*0.66, lat) + dessine(hw*0.66, lat);
    else if (ailId === '2+1') g += dessine(0, hL * 0.13) + dessine(-hw*0.58, lat) + dessine(hw*0.58, lat);
    /* le plug de leash */
    g += `<circle cx="${cx}" cy="${(yF - hL*0.022 - encoche).toFixed(1)}" r="${Math.max(1.4, hw*0.035).toFixed(1)}" fill="none" stroke="${trait}" stroke-width="1.2" opacity="0.7"/>`;
    return g;
  }

  function stats(p, items, y) {
    const it = (items || []).filter(x => x && String(x[0] || '').trim());
    if (!it.length) return '';
    const x0 = 54, w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 36, 0.56, 0, 15), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  /* ---------------------------------------------------------------
     LE SPOT, vu du ciel : le large en haut, la plage en bas.

     LE SENS DE DÉFERLEMENT. Une « gauche » est nommée du point de vue du
     surfeur qui la descend, face à la plage. Sur cette vue, le surfeur regarde
     donc vers le BAS de la feuille, et sa gauche tombe à DROITE de la feuille.
     Comme la convention se discute et qu'une flèche vaut mieux qu'un débat,
     le sens est AUSSI écrit en toutes lettres à côté de la flèche.
     --------------------------------------------------------------- */
  const BREAKS = {
    beach: { label: 'Beach break' }, reef: { label: 'Reef break' },
    point: { label: 'Point break' }, rivermouth: { label: 'Rivermouth' },
  };
  const SENS = { gauche: 'Gauche', droite: 'Droite', 'a-frame': 'A-frame' };

  function spot(cx, cy, W, H, brId, sensId, p) {
    const X = cx - W/2, Y = cy - H/2, yPlage = Y + H * 0.86;
    let g = `<rect x="${X}" y="${Y}" width="${W}" height="${H}" rx="12" fill="${p.eau}"/>`;

    /* Le trait de côte, dont la forme dit le type de break. La plage n'est
       qu'un liseré : c'est l'eau qui porte l'affiche, pas le sable. */
    let cote = `M ${X} ${yPlage.toFixed(1)}`;
    if (brId === 'point') cote += ` L ${(X + W*0.16).toFixed(1)} ${yPlage.toFixed(1)} Q ${(X + W*0.30).toFixed(1)} ${(Y + H*0.34).toFixed(1)} ${(X + W*0.42).toFixed(1)} ${yPlage.toFixed(1)} L ${(X+W).toFixed(1)} ${yPlage.toFixed(1)}`;
    else if (brId === 'rivermouth') cote += ` L ${(X + W*0.44).toFixed(1)} ${yPlage.toFixed(1)} L ${(X + W*0.49).toFixed(1)} ${(Y + H*0.97).toFixed(1)} L ${(X + W*0.55).toFixed(1)} ${yPlage.toFixed(1)} L ${(X+W).toFixed(1)} ${yPlage.toFixed(1)}`;
    else cote += ` L ${(X+W).toFixed(1)} ${yPlage.toFixed(1)}`;
    g += `<path d="${cote} L ${(X+W).toFixed(1)} ${(Y+H).toFixed(1)} L ${X} ${(Y+H).toFixed(1)} Z" fill="${p.sable}"/>`
      + `<path d="${cote}" fill="none" stroke="${p.ink}" stroke-width="2" opacity="0.30"/>`;

    const sens = sensId === 'droite' ? -1 : 1;
    const xPic = sensId === 'a-frame' ? cx : cx - sens * W * 0.28;

    /* Le fond, sous le pic — banc de sable ou platier, jamais les deux. */
    if (brId === 'beach')
      g += `<ellipse cx="${xPic.toFixed(1)}" cy="${(Y + H*0.60).toFixed(1)}" rx="${(W*0.17).toFixed(1)}" ry="${(H*0.10).toFixed(1)}" fill="none" stroke="${p.sable}" stroke-width="1.6" stroke-dasharray="6 6" opacity="0.65"/>`;
    else if (brId === 'reef') {
      g += `<ellipse cx="${xPic.toFixed(1)}" cy="${(Y + H*0.60).toFixed(1)}" rx="${(W*0.15).toFixed(1)}" ry="${(H*0.09).toFixed(1)}" fill="${p.card}" opacity="0.40"/>`;
      for (let i = -3; i <= 3; i++)
        g += `<line x1="${(xPic + i*W*0.038 - 9).toFixed(1)}" y1="${(Y + H*0.66).toFixed(1)}" x2="${(xPic + i*W*0.038 + 9).toFixed(1)}" y2="${(Y + H*0.54).toFixed(1)}" stroke="${p.ink}" stroke-width="1.2" opacity="0.28"/>`;
    }

    /* LES TRAINS DE HOULE, au large : des lignes longues et presque droites,
       à peine inclinées. Ce sont elles qui donnent la profondeur ; sans elles
       les crêtes qui déferlent partaient en éventail depuis le pic et ne
       ressemblaient plus à un spot vu du ciel. */
    for (let i = 0; i < 3; i++) {
      const yy = Y + H * (0.09 + i * 0.075);
      g += `<path d="M ${X.toFixed(1)} ${(yy + H*0.028).toFixed(1)} Q ${cx.toFixed(1)} ${(yy - H*0.020).toFixed(1)} ${(X + W).toFixed(1)} ${(yy + H*0.028).toFixed(1)}"`
        + ` fill="none" stroke="#FFFFFF" stroke-width="1.6" opacity="${(0.20 + i*0.07).toFixed(2)}"/>`;
    }

    /* LA VAGUE QUI DÉFERLE. Chaque crête part droite au large du pic, puis
       s'enroule vers l'épaule ; plus elle est proche du bord, plus son
       déferlement a progressé, et l'écume la suit en pointillé. */
    const epaules = sensId === 'a-frame' ? [1, -1] : [sens];
    for (let i = 0; i < 3; i++) {
      const yy = Y + H * (0.36 + i * 0.115);
      const avance = W * (0.20 + i * 0.13);
      for (const e of epaules) {
        const xFin = xPic + e * avance, yFin = yy + H * 0.075;
        g += `<path d="M ${(xPic - e * W * 0.16).toFixed(1)} ${(yy - H*0.012).toFixed(1)} L ${xPic.toFixed(1)} ${yy.toFixed(1)}`
          + ` Q ${(xPic + e * avance * 0.62).toFixed(1)} ${(yy + H*0.004).toFixed(1)} ${xFin.toFixed(1)} ${yFin.toFixed(1)}"`
          + ` fill="none" stroke="#FFFFFF" stroke-width="${(3.2 - i*0.4).toFixed(1)}" opacity="${(0.95 - i*0.12).toFixed(2)}" stroke-linecap="round"/>`;
        /* l'écume, derrière la crête */
        g += `<path d="M ${xPic.toFixed(1)} ${(yy + H*0.022).toFixed(1)}`
          + ` Q ${(xPic + e * avance * 0.62).toFixed(1)} ${(yy + H*0.026).toFixed(1)} ${xFin.toFixed(1)} ${(yFin + H*0.020).toFixed(1)}"`
          + ` fill="none" stroke="#FFFFFF" stroke-width="2" stroke-dasharray="3 5" opacity="${(0.45 - i*0.10).toFixed(2)}"/>`;
      }
    }
    g += `<circle cx="${xPic.toFixed(1)}" cy="${(Y + H*0.36).toFixed(1)}" r="6.5" fill="${p.accent}"/>`
      + T(xPic, Y + H*0.36 - 16, 10.5, p.accent, 'LE PIC', { w:700, ls:2.4 });

    /* La flèche de déferlement, DOUBLÉE DU MOT : la convention de nommage se
       discute, une flèche accompagnée de son libellé ne se discute pas. */
    const yFl = Y + H * 0.77;
    for (const e of epaules) {
      const x2 = xPic + e * W * 0.30;
      g += `<line x1="${xPic.toFixed(1)}" y1="${yFl.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${yFl.toFixed(1)}" stroke="${p.accent}" stroke-width="3"/>`
        + `<path d="M ${x2.toFixed(1)} ${yFl.toFixed(1)} l ${(e > 0 ? -13 : 13)} -7 l 0 14 z" fill="${p.accent}"/>`;
    }
    g += T(xPic + (sensId === 'a-frame' ? 0 : sens * W * 0.15), yFl - 14, 13, p.accent, up(SENS[sensId] || 'Gauche'), { w:700, ls:3 });
    return g;
  }

  /* Filigrane : un contour de planche, nose en haut. */
  function filigrane(p) {
    const cx = 400, y0 = 292, h = 540, hw = 82;
    return `<g opacity="0.055"><path d="M ${cx} ${y0}`
      + ` C ${(cx + hw * 0.34).toFixed(1)} ${(y0 + h * 0.13).toFixed(1)} ${cx + hw} ${(y0 + h * 0.31).toFixed(1)} ${cx + hw} ${(y0 + h * 0.52).toFixed(1)}`
      + ` C ${cx + hw} ${(y0 + h * 0.75).toFixed(1)} ${(cx + hw * 0.60).toFixed(1)} ${(y0 + h * 0.89).toFixed(1)} ${(cx + hw * 0.40).toFixed(1)} ${(y0 + h).toFixed(1)}`
      + ` L ${(cx - hw * 0.40).toFixed(1)} ${(y0 + h).toFixed(1)}`
      + ` C ${(cx - hw * 0.60).toFixed(1)} ${(y0 + h * 0.89).toFixed(1)} ${cx - hw} ${(y0 + h * 0.75).toFixed(1)} ${cx - hw} ${(y0 + h * 0.52).toFixed(1)}`
      + ` C ${cx - hw} ${(y0 + h * 0.31).toFixed(1)} ${(cx - hw * 0.34).toFixed(1)} ${(y0 + h * 0.13).toFixed(1)} ${cx} ${y0} Z" fill="${p.ink}"/></g>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.ocean;
    const mode = String(data.mode || 'planche').toLowerCase();
    const cx = PW / 2;

    const DEF = { planche: 'MA PLANCHE', quiver: 'MON QUIVER', spot: 'LE SPOT', session: 'LA SESSION', heat: 'LE HEAT' };
    const titre = up(data.titre) || DEF[mode] || 'MA PLANCHE';
    const ts = fit(titre, 690, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || up(data.club) || 'SURF';
    const sous = [up(data.club), up(data.lieu)].filter(Boolean).join(' · ');

    let corps = '', barre = '', pied = 0;

    if (mode === 'planche') {
      const tId = cle(data.type, PLANCHES, 'shortboard'), def = PLANCHES[tId];
      const L = longueurPouces(data.pieds, data.pouces) || 74;
      const W = pouces(data.largeur) || 19.25;
      const zone = 596, s = Math.min(zone / L, 300 / W);
      const y0 = 596 - (L * s) / 2;
      corps = contour(cx, y0, L, W, def, cle(data.tail, TAILS, def.tail), cle(data.ailerons, AILERONS, def.ailerons), s, p, p.ink);

      /* La cote de longueur, en planche technique, à gauche du contour :
         deux segments et un vide pour le chiffre. */
      const dx = Math.max(MX + 16, cx - (W / 2) * s - 64), yF = y0 + L * s, my = (y0 + yF) / 2;
      corps += `<line x1="${dx}" y1="${y0.toFixed(1)}" x2="${dx}" y2="${(my - 26).toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
        + `<line x1="${dx}" y1="${(my + 26).toFixed(1)}" x2="${dx}" y2="${yF.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
        + T(dx, my + 7, 19, p.muted, enPieds(L) + '"', { f:'Oswald', w:700 });
      for (const yy of [y0, yF])
        corps += `<line x1="${dx - 7}" y1="${yy.toFixed(1)}" x2="${dx + 7}" y2="${yy.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`;

      /* La cote de LARGEUR, au maître-bau et à droite : elle équilibre la
         planche technique et c'est la deuxième dimension qu'un surfeur lit. */
      const hwPx = (W / 2) * s, yv = y0 + (L * s) * def.pv, dxD = cx + hwPx + 58;
      corps += `<line x1="${(cx + hwPx + 8).toFixed(1)}" y1="${yv.toFixed(1)}" x2="${dxD.toFixed(1)}" y2="${yv.toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
        + `<line x1="${dxD.toFixed(1)}" y1="${(yv - 7).toFixed(1)}" x2="${dxD.toFixed(1)}" y2="${(yv + 7).toFixed(1)}" stroke="${p.muted}" stroke-width="1.2"/>`
        + T(dxD + 10, yv + 6, 17, p.muted, esc(String(data.largeur || '').trim() || String(W)) + '"', { f:'Oswald', w:700, a:'start' });

      /* Les cotes en notation de shaper, sur une seule ligne. Apostrophe et
         guillemet en ASCII : le prime typographique (U+2032) n'existe ni dans
         Sora ni dans Oswald, et sortirait en tofu à l'impression. */
      const vol = String(data.volume || '').trim();
      const cotes = `${enPieds(L)}" x ${esc(String(data.largeur || '').trim() || String(W))}" x ${esc(String(data.epaisseur || '').trim() || '2 1/2')}"`
        + (vol ? ` · ${esc(vol)} L` : '');
      corps += T(cx, 912, 11.5, p.muted, `${up(def.label)} · ${up(TAILS[cle(data.tail, TAILS, def.tail)])} · ${up(AILERONS[cle(data.ailerons, AILERONS, def.ailerons)])}`, { w:600, ls:2.6 })
        + T(cx, 960, fit(cotes, 664, 32, 0.56, 1, 15), p.ink, cotes, { f:'Oswald', w:700, ls:1 });
      const bas2 = [String(data.shaper || '').trim() ? `SHAPÉ PAR ${esc(up(data.shaper))}` : '', esc(up(data.modele))].filter(Boolean).join(' · ');
      if (bas2) corps += T(cx, 994, 12, p.muted, bas2, { w:600, ls:2.4 });
      pied = bas2 ? 1032 : 1004;

    } else if (mode === 'quiver') {
      /* De 2 à 6 planches à la MÊME échelle : c'est l'écart de taille qui est
         le sujet de l'affiche, pas chaque planche prise isolément. */
      const l = [];
      for (let i = 1; i <= 6; i++) {
        const raw = String(data['q' + i] || '').trim(); if (!raw) continue;
        const c = raw.split('|').map(x => (x || '').trim());
        const tId = cle(c[0], PLANCHES, 'shortboard');
        const m = String(c[1] || '').match(/^(\d+)\s*['’]\s*(.*)$/);
        const L = m ? longueurPouces(m[1], m[2]) : pouces(c[1]);
        const W = pouces(c[2]);
        if (L && W) l.push({ tId, L, W, ep: c[3] || '', nom: c[4] || '' });
      }
      if (l.length) {
        const Lmax = Math.max.apply(null, l.map(x => x.L));
        const largeurTotale = l.reduce((a, x) => a + x.W, 0) + (l.length - 1) * 3.5;
        const HAUT = 512, y0 = 318, yBase = y0 + HAUT;
        const s = Math.min(HAUT / Lmax, (PW - 2*MX - 20) / largeurTotale);
        let x = cx - (largeurTotale * s) / 2;
        corps += `<line x1="${MX}" y1="${(yBase + 14).toFixed(1)}" x2="${PW - MX}" y2="${(yBase + 14).toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`;
        l.forEach((b, i) => {
          const def = PLANCHES[b.tId], w = b.W * s;
          corps += contour(x + w/2, y0, b.L, b.W, def, def.tail, def.ailerons, s, p, p.ink);
          corps += T(x + w/2, yBase + 38, 14, p.ink, enPieds(b.L) + '"', { f:'Oswald', w:700 });
          /* Le libellé d'usage est AJUSTÉ à la largeur de sa planche, pas
             tronqué à l'aveugle : cinq planches étroites donnaient cinq
             libellés qui se marchaient dessus. */
          if (b.nom) corps += T(x + w/2, yBase + 58, fit(up(b.nom), Math.max(56, w - 4), 11, 0.58, 1.4, 7.5), p.muted, esc(up(b.nom)), { w:600, ls:1.4 });
          x += (b.W + 3.5) * s;
        });
        barre = stats(p, [[String(l.length), l.length > 1 ? 'Planches' : 'Planche'],
          [enPieds(Math.min.apply(null, l.map(v => v.L))) + '"', 'La plus courte'],
          [enPieds(Lmax) + '"', 'La plus longue']], 964);
      } else corps = T(cx, 600, 19, p.muted, 'FORMAT : TYPE, LONGUEUR, LARGEUR, EPAISSEUR, USAGE', { w:600, ls:1.5 });
      pied = 1032;

    } else if (mode === 'spot') {
      const brId = cle(data.break, BREAKS, 'beach'), sensId = cle(data.sens, SENS, 'gauche');
      corps = spot(cx, 566, PW - 2*MX, 500, brId, sensId, p)
        + T(cx, 856, 11.5, p.muted, `${up(BREAKS[brId].label)} · LE LARGE EN HAUT`, { w:600, ls:2.8 });
      barre = stats(p, [[esc(up(data.houle)) || '—', 'Houle'], [esc(up(data.vent)) || '—', 'Vent'], [esc(up(data.maree)) || '—', 'Marée']], 962);
      pied = 1030;

    } else if (mode === 'session') {
      const l = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['l' + i] || '').trim(); if (!raw) continue;
        const [lab, v] = raw.split('|').map(x => (x || '').trim());
        if (lab && v) l.push([lab, v]);
      }
      if (l.length) {
        const zone = 600, pas = Math.min(96, zone / l.length), y0 = 308 + (zone - pas*l.length) / 2;
        l.forEach((r, i) => {
          const y = y0 + i * pas, dernier = i === l.length - 1;
          corps += T(MX, y, 17, p.muted, esc(up(r[0])), { w:600, ls:2, a:'start' })
            + T(PW - MX, y + 8, fit(r[1], 440, 42, 0.58, 0, 18), dernier ? p.accent : p.ink, esc(r[1]), { f:'Oswald', w:700, a:'end' });
          if (!dernier) corps += `<line x1="${MX}" y1="${(y + pas/2 - 14).toFixed(1)}" x2="${PW-MX}" y2="${(y + pas/2 - 14).toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`;
        });
      } else corps = T(cx, 600, 20, p.muted, 'FORMAT : LIBELLÉ, BARRE VERTICALE, VALEUR', { w:600, ls:2 });
      pied = 976;

    } else { /* heat */
      const notes = [];
      for (let i = 1; i <= 6; i++) {
        const v = parseFloat(String(data['h' + i] || '').replace(',', '.'));
        if (Number.isFinite(v) && v >= 0 && v <= 10) notes.push(Math.round(v * 10) / 10);
      }
      const nb = Math.max(1, Math.min(6, parseInt(String(data.comptees || '2'), 10) || 2));
      const X = cx - 96, Y0 = 316, Y1 = 856;
      const yn = v => Y1 - (Y1 - Y0) * (v / 10);
      /* Colonne graduée de 0 à 10, SANS bande descriptive : la WSL et l'ISA
         n'utilisent pas les mêmes, et l'affiche ne peut pas savoir sous quel
         règlement la série a été jugée. */
      corps = `<rect x="${(X - 26).toFixed(1)}" y="${Y0}" width="52" height="${(Y1 - Y0).toFixed(1)}" rx="10" fill="${p.card}"/>`;
      for (let v = 0; v <= 10; v++) {
        const y = yn(v), fort = v % 5 === 0;
        corps += `<line x1="${(X - 26).toFixed(1)}" y1="${y.toFixed(1)}" x2="${(X + (fort ? 34 : 26)).toFixed(1)}" y2="${y.toFixed(1)}" stroke="${p.line}" stroke-width="${fort ? 2 : 1.2}"/>`
          + (fort ? T(X - 38, y + 5, 13, p.muted, String(v), { f:'Oswald', w:700, a:'end' }) : '');
      }
      const comptees = notes.slice().sort((a, b) => b - a).slice(0, nb);
      const reste = comptees.slice();
      notes.forEach((v, i) => {
        const k = reste.indexOf(v), compte = k >= 0;
        if (compte) reste.splice(k, 1);
        const y = yn(v);
        corps += `<line x1="${(X + 40).toFixed(1)}" y1="${y.toFixed(1)}" x2="${(PW - MX).toFixed(1)}" y2="${y.toFixed(1)}" stroke="${compte ? p.accent : p.muted}" stroke-width="${compte ? 2.4 : 1.2}"${compte ? '' : ' stroke-dasharray="5 6"'}/>`
          + `<circle cx="${(X + 40).toFixed(1)}" cy="${y.toFixed(1)}" r="${compte ? 8 : 5}" fill="${compte ? p.accent : p.bg}" stroke="${compte ? p.accent : p.muted}" stroke-width="2"/>`
          + T(PW - MX, y - 10, compte ? 26 : 17, compte ? p.ink : p.muted, v.toFixed(1), { f:'Oswald', w:700, a:'end' });
      });
      if (!notes.length) corps += T(cx + 60, 600, 18, p.muted, 'VOS NOTES DE VAGUE, DE 0 À 10', { w:600, ls:2 });
      const total = comptees.reduce((a, b) => a + b, 0);
      corps += T(cx, 906, 11.5, p.muted, `LES ${nb} MEILLEURES VAGUES COMPTENT`, { w:600, ls:2.8 });
      barre = stats(p, [[notes.length ? total.toFixed(1) : '—', `sur ${(nb * 10).toFixed(0)}`],
        [String(notes.length), 'Vagues notées'],
        [esc(up(data.resultat)) || '—', 'Résultat']], 990);
      pied = 1044;
    }

    /* Le filigrane n'est posé que sur les modes où la place est vraiment
       vide : là où un dessin occupe déjà l'affiche, il ne ferait que salir. */
    const fili = ["session","heat"].indexOf(mode) >= 0 ? filigrane(p) : '';
    const bas = [esc(up(data.joueur)), esc(up(data.equipe))].filter(Boolean).join(' · ');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${fili}
${corps}
${barre}
${pied && bas ? T(cx, pied, fit(bas, 690, 19, 0.60, 1, 12), p.ink, bas, { f:'Oswald', w:700, ls:1 }) : ''}
</svg>`;
  }

  window.SNSfPlanche = { render, PALETTES, PLANCHES, TAILS, AILERONS, BREAKS, SENS };
})();
